module.exports = __webpack_public_path__ + "static/media/report1.5f1e6734.png";